import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import i18n from "../../../../Utils/i18next/i18next";
const { t } = i18n;
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:notifyUser.index" },
      {
        key: "contact.name",
        name: "global:notifyUser.contact",
      },
      {
        key: "firstName",
        name: "global:notifyUser.firstNameAndLast",
      },
      {
        key: "lastName",
        name: "global:notifyUser.lastName",
      },
      {
        key: "login",
        name: "global:notifyUser.login",
      },

      { key: "status.name", name: "global:secret.status" },
    ],
    selectedSearchFields: [
      "index",
      "status.name",
      "contact.name",
      "firstName",
      "lastName",
    ],
    dictionaryFields: [],
    url: "notifyuser",
  },
};

const notifyUserReducer = createSlice({
  name: "notifyuser",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = notifyUserReducer.actions;

export default notifyUserReducer.reducer;
